import { mapGetters, mapState } from 'vuex';
import ApiService from '@/services/apiService';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
import healthStatusMixin from '@/components/core/virtualDevice/healthStatusMixin';
export default {
  name: 'ViewVirtualDevicesList',
  mixins: [healthStatusMixin, multiSearchMixin],
  data() {
    return {
      showDialogStatistics: false,
      showExportDialog: false,
      // only show "map" button if the current user has access to ANY devices with geo-coordinates
      hasAnyGeoDevices: false,
      favouriteFilter: false,
      showDialogCreate: false,
      accountFilterReady: false,
      showDialogEditAll: false,
      setSelectedAccounts: [],
      showBulkImportDialog: false,
      // can't use mapGetters as these need to be mutated at times
      initOperator: this.$store.getters['app/getVirtualDeviceListSearchOperator'],
      initSearchItems: this.$store.getters['app/getVirtualDeviceListSearchItems'],
      selectedRows: [],
      // moved bunch of items for search in `multiSearchMixin`

      // Bulk edit
      showBulkEditAllDialog: false,
      isCalculating: false,
      isCalculatingError: false,
      belongToSameAccount: false,
      groupsTags: null,
      totalCountItems: null,
      listIsReadyToFetch: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
    }),
    showEditSelectedBtn() {
      return this.permissions['all.manage'] || this.permissions['VirtualDevice.manage'] || this.permissions['VirtualDevice.write'];
    },
    isDeviceManager() {
      return this.permissions['VirtualDevice.manage'];
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    statisticsSearchTypes() {
      return this.searchTypes.filter(st => st.param !== 'zone');
    },
    isBulkEditAllBtnDisabled() {
      return this.selectedRows.length === 0 || this.selectedRows.length > 500;
    },
    bulkEditAllBtnDisabledTooltip() {
      return this.isBulkEditAllBtnDisabled ? this.$i18n_t('DigitalTwin.VirtualDevice.bulkEditAlert') : '';
    },
    devices() {
      return this.selectedRows;
    },
    isDeviceDriverActive() {
      return !this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback');
    }
  },
  watch: {
    searchItems(newValue) {
      this.$store.dispatch('app/updateVirtualDeviceListSearch', {
        items: newValue
      });
    },
    searchOperator(newValue) {
      this.$store.dispatch('app/updateVirtualDeviceListSearch', {
        operator: newValue
      });
    },
    totalCountItems() {
      this.getSearchedResults();
    }
    // language-check to update search-types in searchTypesMixin
  },
  created() {
    const {
      view,
      mode
    } = this.$route.query;
    if (!view) {
      this.listIsReadyToFetch = true;
    } else {
      this.listIsReadyToFetch = false;
      this.setUpMonitoringViewList(view, mode);
    }
  },
  mounted() {
    ApiService.virtualDeviceCheckForGeoClusters(this).then(res => {
      this.hasAnyGeoDevices = res.hasGeoDevices;
    }).catch(error => {
      console.error(error);
    });
  },
  methods: {
    setUpMonitoringViewList(viewId, mode) {
      this.$router.replace({
        query: null
      });
      ApiService.virtualDeviceViewGet(this, viewId).then(data => {
        const search = data.viewConfig.searchItems;
        this.initOperator = data.viewConfig.searchOperator;
        this.initSearchItems = search.map(item => ({
          param: item.variable,
          key: item.key,
          search: item.search
        }));

        // persist search items and operator in store
        this.$store.dispatch('app/updateVirtualDeviceListSearch', {
          items: this.initSearchItems,
          operator: this.initOperator
        });
        if (mode === 'warnings') {
          this.initSearchItems.push({
            param: 'health',
            search: {
              value: '1',
              text: 'Warning'
            }
          });
        }
        if (mode === 'errors') {
          this.initSearchItems.push({
            param: 'health',
            search: {
              value: '2',
              text: 'Alert'
            }
          });
        }
        const accounts = [data.tenantId];
        this.setSelectedAccounts = accounts;
        this.$nextTick(() => {
          this.listIsReadyToFetch = true;
        });
      }).catch(() => {
        this.listIsReadyToFetch = true;
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.snacks.loadMonitoringViewFailed'), 'error');
      });
    },
    updateList() {
      this.$refs.list.fetchList();
    },
    updateRowsSelected(rows) {
      if (rows && rows.length && rows[0].id) {
        this.selectedRows = rows;
      } else {
        this.selectedRows = [];
      }
    },
    checkDevicesAccount() {
      this.isCalculating = true;
      let devices = {
        virtualDevicesIds: []
      };
      if (!this.isBulkEditAllBtnDisabled) {
        this.selectedRows = this.devices;
      }
      devices.virtualDevicesIds = this.selectedRows.map(item => item.id);
      ApiService.precalculationBackgroundRunner(devices).then(result => {
        this.isCalculating = false;
        this.belongToSameAccount = result.data.belongToSameAccount;
      }).catch(error => {
        console.error(error);
        this.isCalculatingError = true;
      });
    },
    finishedCreating() {
      this.showDialogCreate = false;
      this.updateList();
    },
    showBulkEditDialog() {
      this.checkDevicesAccount();
      this.showBulkEditAllDialog = true;
    },
    closeDialog() {
      this.selectedRows = [];
      this.showBulkEditAllDialog = false;
      this.$emit('close-step-form');
      this.updateList();
      this.getSearchedResults();
    },
    closeDialogBulkImport() {
      this.showBulkImportDialog = false;
    },
    setItemsResults(items) {
      this.selectedRows = items.virtualDevices;
    },
    getSearchedResults() {
      if (this.totalCountItems > 500) {
        return;
      }
      // fetch the whole list on-demand here
      this.$refs['list'].fetchResult(true, 'load-all').then(result => {
        this.setItemsResults(result);
      }).catch(() => {
        // nothing to do here, error is caught inside fetchResult already
      });
    },
    setTotalCountItems(payload) {
      this.totalCountItems = payload.totalCount;
    },
    showDialogBulkImport() {
      this.showBulkImportDialog = true;
    }
  }
};